import Box, { IBoxProps } from '../../../Box';
import Divider from '../../../Divider';

export interface IPanelHeaderProps extends IBoxProps {
    hideBottomDivider?: boolean;
}

const PanelHeader = (props: IPanelHeaderProps) => {
  const {
    children, hideBottomDivider = false, ...rest
  } = props;
  return (
    <>
      <Box p={2} {...rest}>
        {children}
      </Box>
      {!hideBottomDivider && <Divider />}
    </>
  );
};

export default PanelHeader;
